import { Injectable } from '@angular/core';
import { SpaEventService } from './spaEvents.service';

@Injectable()
export class ApplicationService {
	public webVersion: string | null = null;

	// biome-ignore lint/correctness/noUnusedPrivateClassMembers: suppressed due to migration - should be fixed
	constructor(private spaEventService: SpaEventService) {}
}
